import { navigateTo, useRequestURL } from '#imports'

/**
 * Reload the browser.
 * Automatically reloads `window.opener`, if it is our site
 * @returns A function that accepts an optional redirect URL
 */
export const useReload = () => {
    const url = useRequestURL()

    return (redirect?: string) => {
        if (redirect) {
            if (!redirect.startsWith('http')) {
                redirect = new URL(redirect, url.origin).toString()
            }

            return navigateTo(redirect, { external: true })
        }

        if (import.meta.client) {
            window.scrollTo(0, 0)

            // If signup or log in is from an opener from one of our own sites, reload the opener
            if (document.referrer && window.opener && document.referrer.split('/')[2] === window.location.href.split('/')[2]) {
                window.opener.location.reload()
            }

            window.location.reload()
        }
    }
}
